<template class='purchase-modal'>
    <md-card style="margin: 0" class='purchase-modal'>
    <md-card-header>
      <div class='md-title'>
        Purchase License
        <md-icon v-on:click.native="closePModal">close</md-icon>
      </div>

    </md-card-header>
    <md-card-content>
    <div style="display: flex; justify-content: space-between; flex-wrap: wrap">
      <div class="purchaseCard">
        <form @submit.prevent='handleSubmit'>
          <md-field style="margin-top: 38px">
            <label>Name</label>
            <md-input v-model="name"></md-input>
          </md-field>
          <md-field>
            <label>Company Name</label>
            <md-input v-model="companyName"></md-input>
          </md-field>
            <label>payment information</label>
          <div ref="card"></div>
          <div id="card-element">
            <!-- A Stripe Element will be inserted here. -->
          </div>

            <div style="margin-top: 12px">
            <md-button
              type="submit"
              class="md-success md-lg submit"
            >
              Purchase
            </md-button>
            <md-progress-spinner v-if="isLoading == true" md-mode="indeterminate" class="md-accent lic-spin" :md-diameter="30" :md-stroke="3"></md-progress-spinner>
            </div>
        </form>
      </div>
    <div class="purchaseReview">
      <div class="p-item">
        <p>Item</p>
        <p class="subtotal">{{description[purchaseType]}}</p>
        <p>Subtotal</p>
      </div>
      <div>
        <p>total</p>
        <p class="total">{{price[purchaseType]}}</p>
        <h5><b>{{price[purchaseType]}}</b></h5>
      </div>
    </div>
    </div>
    </md-card-content>
    </md-card>
</template>
<script>

  import api from "@/api";
  export default {
    data() {
      return {
        card: null,
        stripe: null,
        companyName: '',
        description: {
          'monthly': 'Gold level monthly subscription',
          'six': 'Gold level 6-month subscription',
          'year': 'Gold level yearly subscription',
          'silver': 'Silver level yearly subscription'
        },
        price: {
          'monthly': '$1.00',
          'six': '$1.00',
          'year': '$1.00',
          'silver': '$1.00'
        },
        isLoading: false,
      }
    },
    props: ['purchaseType'],
    methods: {
      handleSubmit() {
        // get the secret from our backend.
	this.isLoading = true;
        api.getPaymentIntent({service: null, email: 'cool@beans.com'})
          .then(a => {
            const { data } = a;
            return data.client_secret;
	  })
	  .then(secret => {
            console.log(secret);
	    return this.stripe.confirmCardPayment(secret, {
		   payment_method: {
		      card: this.card,
		      billing_details: {
		      name: 'T'
		      }
                  }
            });
	  }).then(result => {
	    console.log(result);
		  if (result.error) {
		    this.isLoading = false;
		    this.notify(result.error.message, 'danger');
		  } else {
		    api.addNewLicense({type: this.purchaseType})
		      .then((r) => {
			this.isLoading = false;
			this.notify('Congrats, you are registered for SafeCore', 'success');
			this.$router.push('/user');
		      })
		  }
	  })
      }, 
      notify(message, type) {
        this.$notify({
          timeout: 3000,
          message,
          horizontalAlign: 'left',
          verticalAlign: 'top',
          type
        });
      },
      closePModal(){
        this.$emit('closeModal');
      }
    },
    mounted: function () {
      var card = undefined;
      let stripe = Stripe('pk_live_57VFLPuEjRXuWe9E96ui50tv00Smfq4CS9'),
          elements = stripe.elements()
      this.stripe = stripe;
      var elementStyles = {
        base: {
          height: '32px',
          padding: 0,
          flex: 1,
          border: '1px solid grey',
          background: 'none',
          transition: '.4s cubic-bezier(.25,.8,.25,1)',
          transitionProperty: 'font-size,padding-top,color',
          fontSize: '16px',
          lineHeight: '32px',
        },
        invalid: {
          color: '#fff',
          ':focus': {
            color: '#FA755A',
          },
          '::placeholder': {
            color: '#FFCCA5',
          },
        },
      };
      card = elements.create('card', {style: elementStyles});
      this.card = card
      card.mount(this.$refs.card);
    }
}
</script>
<style lang="scss">
.lic-spin {
  margin-left: 10px;
  margin-top: 10px;
}

.purchaseCard {
  width: 400px;
}

.purchaseReview{
  display: flex;
  width: 400px;
  .p-item {
    margin-left: 30px;
    .subtotal{
      padding-right: 100px;
      padding-bottom: 80px;
      border-bottom: 1px solid lightgrey
    }
  }
  .total {
    padding-bottom: 80px; border-bottom: 1px solid lightgrey;
  }
}

.md-title {
  .md-icon {
    float: right;
  }
}

@media (max-width: 500px){
  .purchaseReview {
    width: 100%;
    flex-wrap: wrap;
    .p-item {
      .subtotal {
        // width: 90%;
        padding-right: 10px;
      }
    }
  }

  .purchaseCard {
    width: 100%;
  }
}


</style>
